import * as React from "react";

function Up(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={20} height={19} fill="none" {...props}>
      <path
        d="M1.367 13.164s2.749 4.272 5.392 4.445c2.642.173 3.421-.987 3.421-.987"
        stroke="#fff"
        strokeWidth={2}
      />
      <path d="M15.58.967l1.782 6.983-7.655-1.676L15.581.967z" fill="#fff" />
      <path
        d="M13.24 9.289l.693-2.667M12.387 12.523l.666-2.322M11.095 15.61l.867-2.18"
        stroke="#fff"
        strokeWidth={2}
      />
    </svg>
  );
}

const MemoUp = React.memo(Up);
export default MemoUp;
